/**
 * @description 用于将input输入的值进行过滤，防止XSS攻击
 * @param input {string} 输入的值
 * @returns {string} 输出的值
 * @example
 *  onChange={e => setCurrentChannelName(filterInputValue(e.target.value))}
 */
export function filterInputValue(input: string): string {
    return input.replace(/[<>"\n\r\t]/g, "");
}

/**
 * @description 用于限制用户名输入的长度
 * @param input 输入的用户名值
 * @param maxLength 最大长度 默认16
 * @returns {string} 输出的值
 */
export function limitInputLength(
    input: string,
    maxLength = 16,
): { val: string; overLimit: boolean } {
    let totalLength = 0;
    let result = "";
    let overLimit = false;
    // @ts-ignore
    for (const char of input) {
        const charLength = /[\u4e00-\u9fa5]/.test(char) ? 2 : 1;
        if (totalLength + charLength > maxLength) {
            overLimit = true;
            break;
        }
        totalLength += charLength;
        result += char;
    }

    return { val: result, overLimit };
}

/**
 * @description 用于将input输入的值限制为只有数字
 * @param input {string} 输入的值
 * @returns {string} 输出的值
 * @example
 *  onChange={e => setCurrentChannelName(filterInputValueForNumber(e.target.value))}
 */
export function filterInputValueForNumber(input: string): string {
    return input.replace(/[^0-9]/g, "");
}
